module.exports = __webpack_public_path__ + "static/media/dentist-light.fb249070.png";